import { useEffect, useState } from "react";
import DropZone from "react-dropzone";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import SpinnerModel from "./SpinnerModel";
import deleteIcon from "../images/delete.svg";
import deleteWhite from "../images/deleteWhite.svg";
import pdf from "../images/pdf.svg";
import { sizeConversion } from "../utils/GeneralUtils";

const Placeholder = ({ getInputProps, getRootProps, noClick, noDrag }: any) => (
  <div {...getRootProps()}>
    <input {...getInputProps()} />
    <p className="placeholderText">
      Drag files here or {" "}
      <span
        className={
          noClick || noDrag ? "placeHolderSpanDisabled" : "placeHolderspan"
        }
      >
        browse
      </span>
    </p>
  </div>
);
const MultipleFileDropZoneField = ({
  allowMultiple,
  acceptedFormats,
  displayAccepedFormats,
  clientQuestionId,
  noClick,
  noDrag,
  maxSize,
  input: { onChange, value },
  meta: { error, touched },
  label,
  disabled,
  deleteTodoFile,
  isRequired,
  helpText,
  preserveFiles,
  preserveBasedOn,
  getDeletedItem,
}: any) => {
  const [modal, setModal] = useState<boolean>(false);
  const [fileDocument, setFileDocument] = useState<any>();
  const [errors, setErrors] = useState<any>();
  const [loader, setLoader] = useState<boolean>(false);
  const [trashFlip,setTrashFlip] = useState<number>();
  const[valueArray,setValueArray]=useState<[]|any>([]);

  useEffect(()=>{
    if (value) {
      setValueArray(value)
    }
  },[value])

  useEffect(() => {
    if (errors && errors?.length > 0) {
      errors.forEach((err: any) => {
        err?.errors?.forEach((each: any) => {
          if (each?.code === "file-too-large") {
            toast.error(
              `Failed to upload. Size limit is ${sizeConversion(maxSize)}.`
            );
          } else if (each?.code === "file-invalid-type") {
            toast.error(
              `Valid formats for file upload are ${acceptedFormats}.`
            );
          } else {
            toast.error(each?.message);
          }
        });
      });
      setErrors([]);
    }
  }, [acceptedFormats, errors, maxSize]);

  const deleteFile = (item:any,index:number) => {
    // onChange(null);
    getDeletedItem && getDeletedItem(item,index)
    if (preserveFiles) {
      const del = valueArray?.filter((each: any) => {
        return preserveBasedOn && item?.[preserveBasedOn] ? 
          each?.[preserveBasedOn] !== item?.[preserveBasedOn]
        : each?.name !== item?.name
      })
      onChange(del)
      // setValueArray(del)
    }
    else {
      deleteTodoFile && deleteTodoFile(item,index);
    }
      setTrashFlip(-1)
  };
  const openFileViewHandler = () => {
    setModal(true);
  };
  const fileViewHandler = (file: any) => {
    if (file.documentId) {
      setLoader(true);
      setFileDocument(null);
      openFileViewHandler();
      // service.getManualTodoFile(file.documentId)
      //   .then((response: any) => {
      //     if (response.status === 200) {
      //       setFileDocument(response.data);
      //       setLoader(false);
      //     }
      //   })
      //   .catch(() => {
      //     setModal(true);
      //   });
    }
  };

  const CancelFileViewHandler = () => {
    setModal(false);
  };
  const flipTrashItem=(index:number)=>{
    setTrashFlip(index)
  }
  const [dragColor, setDragcolor] = useState("");
  return (
    <div className="FileUploadContainer">
      {displayAccepedFormats && <span>Please upload {acceptedFormats} </span>}
      {disabled !== true && (
        <DropZone
          onDragEnter={() => setDragcolor("#4482b1")}
          onDragLeave={() => setDragcolor("")}
          accept={acceptedFormats}
          onDrop={(file, e) => {
            onChange(preserveFiles ? [...file, ...valueArray] : file );
            // setValueArray(preserveFiles ? [...file, ...valueArray] : file)
            e?.length > 0 && setErrors(e);
            setDragcolor("");
          }}
          multiple={allowMultiple}
          noClick={noClick}
          noDrag={noDrag}
          maxSize={maxSize}
          disabled={disabled}
        >
          {(props) => (
            <div className="fileUploadMainContainer">
              <p className="label">
                {label} {isRequired && <span className="input-required">*</span>}
              </p>
              <div className="fileUpload">
                <div
                  className={
                    noClick || noDrag
                      ? "preview-container-diabled"
                      : "preview-container"
                  }
                  style={{ backgroundColor: `${dragColor}` }}
                >
                  {" "}
                  <Placeholder
                    {...props}
                    error={error}
                    touched={touched}
                    noClick={noClick}
                    noDrag={noDrag}
                  />{" "}
                </div>
                {valueArray && valueArray.length > 0 && (
                  <div className="Filepreview">
                    {/* <p className="placeholderText">Uploaded Files</p> */}
                    <div className="imagecontainer">
                      <span></span>
                      {valueArray?.map((item: any,index:number) => (
                        <div key={item?.path}>
                          <div key={item.fileName} className="render-preview">
                            <p
                              className="details"
                              onClick={() => fileViewHandler(item)}
                            > 
                              <img src={pdf} />
                              {item.path?.length > 25
                                ? `${item.path.slice(0, 20)}...`
                                : item.path}
                              { !item?.path && item?.documentName ? item.documentName?.length > 25
                                ? `${item.documentName.slice(0, 20)}...`
                                : item.documentName : <></> }
                            </p>
                            {trashFlip === index ?      
                            <span className="details_Xflip" onClick={()=>deleteFile(item,index)}>
                              <img src={deleteWhite} /> Remove
                            </span>
                            :
                            <span className="details_X" >
                              <img src={deleteIcon} onClick={()=>flipTrashItem(index)} /> 
                            </span>
                            }
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </DropZone>
      )}
      {disabled === true && (
        <div>
          <div className="fileUploadMainContainer">
            <p className="label">{label}</p>
          </div>
          <div className="Filepreview disabled">
            <div className="imagecontainer">
              {value &&
                value.length > 0 &&
                value?.map((item: any) => (
                  <div key={value.indexOf(item)}>
                    <div key={item.fileName} className="render-preview">
                      <p
                        className="details"
                        onClick={() => fileViewHandler(item)}
                      > 
                        <img src={pdf} />
                        {item.path?.length > 25
                          ? `${item.path.slice(0, 20)}...`
                          : item.path}
                      </p>
                    </div>
                  </div>
                ))}
              {value == null ||
                (value && value.length == 0 && (
                  <div>
                    <p>No files are uploaded</p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper"
          isOpen={modal}
          fade={false}
          toggle={openFileViewHandler}
        >
          <ModalHeader toggle={CancelFileViewHandler} className="tc_heading">
            <span>{label} </span>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {loader ? (
                <SpinnerModel
                  value={""}
                  color={"primary"}
                  size={""}
                  type={"border"}
                />
              ) : ""
              // (
              //   <FileViewer
              //     fileType={fileDocument?.fileType}
              //     filePath={`data:application/${fileDocument?.fileType};base64,${fileDocument?.image}`}
              //   />
              // )
              }
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};
export default MultipleFileDropZoneField;
